import { Component, input } from '@angular/core';

@Component({
  selector: 'app-simple-list',
  standalone: true,
  template: `
    <section class="simple-card">
      <h2 class="simple-title">{{ title() }}</h2>

      <ul class="simple-items">
        @for (item of items(); track item) {
          <li>{{ item }}</li>
        }
      </ul>
    </section>
  `,
  styles: [
    `
      .simple-card {
        border: 1px solid var(--border);
        border-radius: 14px;
        background: var(--surface-elevated);
        padding: 16px;
        box-shadow: var(--shadow-card);
      }

      .simple-title {
        font-size: 16px;
        font-weight: 600;
        color: var(--text);
        margin-bottom: 12px;
      }

      .simple-items {
        display: grid;
        gap: 8px;
      }

      .simple-items li {
        border: 1px solid var(--border);
        border-radius: 10px;
        padding: 10px 12px;
        color: var(--text);
        background: var(--bg-surface);
      }
    `,
  ],
})
export class SimpleListComponent {
  readonly title = input<string>('Formulários do projeto');
  readonly items = input<string[]>([]);
}
